module.exports = __webpack_public_path__ + "img/poi-icon.5b57074f.png";